import templateUrl from "emun.on-demand/admin/design-product-prompt.htm";
import DesignProductPromptController from "emun.on-demand/admin/design-product-prompt.controller";
import open from "webmodals/open";

let designProductPrompt = options => {
  let modalInstance = open({
    size: options.size || "xl",
    backdrop: options.backdrop || "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: DesignProductPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default designProductPrompt;
